<template>
    <div>
        <van-popup
            v-model="showpop"
            closeable
            position="top"
        >
            <van-swipe class="my-swipe" indicator-color="white">
                <van-swipe-item v-for="(img,i) in imgs" :key="i">
                    <van-image
                        width="100%"
                        height="auto"
                        :src="img"
                    />
                </van-swipe-item>
            </van-swipe>
        </van-popup>
    </div>
</template>

<script>
    export default {
        name:'star-cmd',
        data(){
            return {
                tabi: 0,
                showpop: false
            }
        },
        props:{
            show: Boolean
        },
        watch:{
            show(){
                return this.showpop = !this.showpop
            }
        },
        computed:{
            imgs(){
                var img = []
                for(var i=0;i<=8;i++){
                    img.push(require('../assets/img/gg/s_'+i+'.jpg'))
                }
                return img
            }
        },
        mounted(){
            //console.log(this.imgs)
        }

    }
</script>

<style lang="scss" scoped>

</style>